import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames(
  'bg-header-background-color',
  'border-b',
  'border-header-border-color'
);

interface Props {
  children: ReactNode;
}

const Header = ({ children }: Props) => (
  <header className={className}>{children}</header>
);

export default Header;
